var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v("© 2023 Your Company Name. All rights reserved.")]),_c('p',[_vm._v("Address: 150 Beach Road #28-05/06 Gateway West, Singapore")]),_c('p',[_vm._v("Contact: "),_c('a',[_vm._v("+65 84078778")])])])])
}]

export { render, staticRenderFns }